/* eslint-disable camelcase */
import { BHAState, FlowEvent } from './types'

export default function (
    state: BHAState = { bitDepth: 0, survey: [], survey_uom: {}, span: { start: 0, end: 0 } },
    event: FlowEvent
): BHAState {
    switch (event?.layer) {
        // BHA layer
        case 0:
            switch (event.type) {
                case 'start':
                    return {
                        ...state,
                        span: event?.events?.info?.currentSpan,
                        unit: event?.events?.info?.unit
                    }
                case 'event':
                    if (Array.isArray(event.events) && event.events.length > 0) {
                        const events = event.events
                        const bha = events
                            .filter(event => event.bha)
                            .map(event => event.bha)
                            .flat()
                        const final_md = events[0]?.final_md
                        return {
                            ...state,
                            bha,
                            final_md
                        }
                    }
            }
        // bit depth (historical and realtime)
        case 1:
        case 2:
            switch (event.type) {
                case 'event':
                    if (Array.isArray(event.events) && event.events[0]?.bitdepth) {
                        return {
                            ...state,
                            bitDepth: parseFloat(event.events[0].bitdepth)
                        }
                    }
            }
            break
        // survey
        case 3:
            switch (event?.type) {
                case 'start':
                    return {
                        ...state,
                        survey_uom: event.events.info.uom,
                        survey: []
                    }
                case 'event':
                    if (Array.isArray(event.events)) {
                        state.survey = event.events

                        return state
                    }
            }
    }

    return state
}
